import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Head from '../../components/head/'
import { Button, notification, Input, Table } from 'antd';
import { connect } from 'react-redux';
import * as cardInfoAction from '../../store/actions/cardInfo'
import * as baseAction from '../../store/actions/base'
import businessQuitTime from '../../utils/businessQuitTime'
import LetterKeyboard from '../../components/LetterKeyboard'
import { queryDrugs, queryDrugPriceHisNew } from '@/utils/request';
import './index.scss'
import leftBtn from "../../assets/icons/DoubleLeftOutlined.svg";

// 磁县code
const cixanHospCode = '13010033'

let cixanColumns = [
  {
    title: '项目名称',
    dataIndex: 'M_NAME',
  },
  {
    title: '规格',
    dataIndex: 'M_SPEC',
  },
  {
    title: '价格',
    dataIndex: 'M_R_PRICE',
  },
  {
    title: '医保类型',
    dataIndex: 'INSUR_LEVEL_NAME',
  }
];

let pubColumns = [
  {
    title: '药品名称',
    dataIndex: '药品名称',
  },
  {
    title: '规格',
    dataIndex: '规格',
  },
  {
    title: '价格',
    dataIndex: '价格',
  },
  {
    title: '药品类型',
    dataIndex: '药品类型',
  },
  {
    title: '批号',
    dataIndex: '批号',
  },
  {
    title: '装量',
    dataIndex: '装量',
  },
  {
    title: '厂家',
    dataIndex: '厂家',
  },
]

/*
 * 药品价格查询
 */
class QueryDrugs extends Component {
  constructor(props){
    super(props);
    this.state = {
      drugsName: '',
      drugsList: [],
      pageSize: 7,
      loading: false,
      columns: [],
      hospCode: '',      
    };

    this.goUpPage = this.goUpPage.bind(this);
    this.goHomePage = this.goHomePage.bind(this);
  }

  componentDidMount(){
    const { base = {} } = this.props
    const { hospitalInfo={} }= base
    this.setState({
      hospCode: hospitalInfo.hospCode,
      columns: hospitalInfo.hospCode === cixanHospCode ? cixanColumns: pubColumns       // 区分磁县
    })
  }

  goHomePage(){
    this.props.history.push('/')
  }
  goUpPage(){
    this.props.history.push('/')
  }

  insertDrugsName(name) {
    this.setState({
      drugsName: name
    })
  }

  // 查询药品
  searchDrug() {
    const that = this
    const { drugsName, hospCode } = this.state

    if(drugsName === ''){
      notification.warning({
        message: '提示',
        description: '请输入要查询的关键词字母',
        duration: 10,
      })
      return ;
    }

    if(hospCode === cixanHospCode){
      queryDrugPriceHisNew({
        DRUGNAME: drugsName.toLowerCase(),
      })
      .then(od => {
        if(od.status){
          that.setState({
            drugsList: od.data,
          })
        }
      })
      .catch(err => {
        that.props.history.push({
          pathname : '/error',
          query : { messageTitle: '失败', messageContent: err.toString()}
        })
      })
    }
    else{
      queryDrugs({
        py: drugsName,
        pagesize: 10000,
        current: 0
      })
      .then(od => {
        if(od.status){
          that.setState({
            drugsList: od.data.data,
          })
        }
      })
      .catch(err => {
        that.props.history.push({
          pathname : '/error',
          query : { messageTitle: '失败', messageContent: err.toString()}
        })
      })
    }
  }

  render() {
    const quitTime = businessQuitTime.drugPrice.drugPrice
    const { drugsList, columns, pageSize, loading } = this.state

    return (
      <div>
        <Head quitTime={quitTime} />

        <div className="context-container clearfix">
          <h2 className="crumbs">药品价格查询</h2>
          <div className="c-content-scroll">
            <div className="drugs-box">
              <div style={{width: "650px", overflow: "hidden", margin: "0 auto"}}>
                <div style={{ width:"500px", float: "left" }}><Input size="large" placeholder="" value={this.state.drugsName} /></div>
                <div style={{ marginLeft: "20px", float: "left" }}><Button type="primary" size="large" onClick={() => this.searchDrug()} className="left">查 询</Button></div>
              </div>
              <div className="pt-20">
                <LetterKeyboard letterText={this.insertDrugsName.bind(this)} />
              </div>
            </div>

            <div className="drugs-table">
              <Table pagination={{ pageSize }}
                columns={columns}
                dataSource={drugsList}
                loading={loading}
                className="mt-25"  />
            </div>
          </div>
        </div>

        <div className="footer">
          <Button type="primary" size="large" onClick={this.goUpPage} className="left"
                  style={{ backgroundColor: "#CEE2EE", border: "1px #B3D5E1 solid", color: "#514F4F"}}
          >
            <img src={leftBtn} width={28} /> 上一步</Button>
          <Button type="primary" size="large" onClick={this.goHomePage}
                  style={{ "backgroundColor": "#bfdfe9", color: "#8D2829", border: "1px #3976A9 solid", "float": "right"}}>
            退 出</Button>
          <div className="address"></div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { base, cardInfo } = state;
  return {
    base,
    cardInfo,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    addBase: (data) => {
      dispatch(baseAction.addBase(data));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(QueryDrugs)
